import axios from "../../axios.js";
import Axios from "axios";
import Vue from "vue";
import { createRequestSequence } from "../requestSequence";

const subscriptionsReportSeq = createRequestSequence();
let subscriptionsReportCancel = null;
const getAllServices = async ({ commit }, data) => {
  const search_param = data ? data.search_param : null;
  let url;
  if (search_param) {
    url = url = `api/service?with_hidden=true&search_param=${search_param}`;
  } else {
    url = `api/service?with_hidden=true`;
  }
  await axios
    .get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      commit("SET_SERVICES", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const getAllSubCategories = async ({ commit }) => {
  const url = `api/subCategory`;
  try {
    const response = await axios.get(url);
    commit("SET_SUB_CATEGORIES", response.data);
  } catch (error) {
    console.log(error);
  }
};
// 403 is already announced by the axios interceptor.
const notifyCategoryFileError = (error, text) => {
  if (error.response && error.response.status === 403) {
    return;
  }
  Vue.notify({ group: "error", text });
};

// The edit modal reads the category's files from the cached list, so it has to be refetched after every
// file change - otherwise reopening the modal shows a tile that is gone (or none at all) and the next
// upload stacks behind the old tile instead of replacing it.
const addServiceCategoryFile = async ({ commit, dispatch }, body) => {
  const url = `api/serviceCategoryFile`;
  try {
    const response = await axios.post(url, body);
    commit("SET_BLANK", null);
    await dispatch("fetchServiceCategoriesWithServices");
    return response.data;
  } catch (error) {
    console.log(error.response);
    notifyCategoryFileError(error, "Nie udało się wgrać pliku");
    return null;
  }
};
const setServiceCategoryFilePriority = async ({ commit }, body) => {
  const url = `api/serviceCategoryFile/${body.id}/priority`;
  try {
    await axios.put(url, { priority: body.priority });
    commit("SET_BLANK", null);
  } catch (error) {
    console.log(error.response);
  }
};
const removeServiceCategoryFile = async ({ commit, dispatch }, id) => {
  const url = `api/serviceCategoryFile/${id}`;
  try {
    await axios.delete(url);
    commit("SET_BLANK", null);
    await dispatch("fetchServiceCategoriesWithServices");
    return true;
  } catch (error) {
    console.log(error);
    notifyCategoryFileError(error, "Nie udało się usunąć pliku");
    return false;
  }
};

const deleteSubCategory = async ({ dispatch }, data) => {
  const url = `api/subCategory/${data.id}`;
  try {
    await axios.delete(url);
    dispatch("getAllSubCategories");
  } catch (error) {
    console.log(error);
  }
};

const getAllLongDistanceServices = ({ commit }) => {
  const url = `api/longDistanceService`;
  axios
    .get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      commit("SET_LONG_DISTANCE_SERVICES", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

// A 422 from the service endpoints carries the readable reason in fields[].error - data.message is only
// the generic "Invalid validation" label, which tells the person editing the service nothing.
const validationMessage = (error) => {
  const data = error.response && error.response.data ? error.response.data : {};
  const fields = data.fields || [];
  return fields.length && fields[0].error ? fields[0].error : data.message;
};

// Obiady carnet settings. The backend reads a MISSING field as "leave it alone" and an empty string as
// "clear the type", so the form always sends the whole block together - otherwise unticking a weekday
// would never reach the database. Weekdays travel as ISO numbers (1 = Monday).
const carnetFields = (data) => ({
  custom_select_days: data.custom_select_days || "",
  recurrence_type: data.recurrence_type || "",
  carnet_weekdays: data.carnet_weekdays || [],
  carnet_days_to_select: data.carnet_days_to_select || null,
  carnet_ignores_holidays: data.carnet_ignores_holidays === true,
  orderable_from: data.orderable_from || "",
  carnet_weekend_delivery: data.carnet_weekend_delivery === true,
  glovo_code_prefix: data.glovo_code_prefix || "",
  glovo_sets_per_day: data.glovo_sets_per_day || null,
});

const addService = async ({ commit }, data) => {
  let formatted = data.price_for
    ? data.price_for.replaceAll("<li>", "<li><span>")
    : "";
  formatted = formatted.replaceAll("</li>", "</span></li>");
  const url = `api/service`;
  const body = {
    name: data.name,
    display_name: data.displayName,
    minimum: data.minimum,
    first_threshold: data.firstThreshold,
    second_threshold: data.secondThreshold,
    multiplier: data.multiplier,
    min: data.min,
    max: data.max,
    type: data.type,
    icon: " ",
    price_for: formatted,
    service_category_id: data.service_category_id,
    need_verification: data.need_verification,
    company_service: data.company_service,
    only_stationary: data.only_stationary,
    sub_category_id: data.sub_category_id,
    service_regulations: data.regulations.map((regulation) => {
      return {
        text: regulation.text,
        is_required: regulation.is_required,
      };
    }),
    service_regulations_when_adding: data.regulationsWhenAdding.map(
      (regulation) => {
        return {
          text: regulation.text,
          is_required: regulation.is_required,
          type: "ADDING_SERVICE",
        };
      },
    ),

    added_duration_hours: data.added_duration_hours,
    promotion_codes_blocked: data.promotion_codes_blocked,
    is_public: data.is_public,
    ...carnetFields(data),
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.post(url, body, config);
    commit("ADD_SERVICE_SUCCESS", res.data);
  } catch (error) {
    console.log(error.response.data);
    commit("ADD_SERVICE_FAIL", error.response.data);
  }
};

const addSubCategory = async ({ dispatch }, data) => {
  const url = `api/subCategory`;
  const body = {
    name: data.name,
    display_name: data.displayName,
    service_category_id: data.serviceCategoryId,
  };
  try {
    await axios.post(url, body);
    dispatch("getAllSubCategories");
  } catch (error) {
    console.log(error);
  }
};

const editSubCategory = async ({ dispatch }, data) => {
  const url = `api/subCategory/${data.id}`;
  let body;
  if (data.is_hidden != null) {
    body = {
      is_hidden: data.is_hidden,
    };
  } else {
    body = {
      name: data.name,
      display_name: data.displayName,
      service_category_id: data.serviceCategoryId,
    };
  }

  try {
    await axios.put(url, body);
    dispatch("getAllSubCategories");
  } catch (error) {
    console.log(error);
  }
};

const addLongDistanceService = async ({ dispatch }, data) => {
  const url = `api/longDistanceService`;
  const body = {
    user_phone: data.user_phone,
    service_id: data.service_id,
    radius: data.radius,
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    await axios.post(url, body, config);
    dispatch("getAllLongDistanceServices");
    return true;
  } catch (error) {
    return error.response.data.error;
  }
};

const editLongDistanceService = async ({ dispatch }, data) => {
  const url = `api/longDistanceService/${data.id}`;
  const body = {
    user_phone: data.user_phone,
    service_id: data.service_id,
    radius: data.radius,
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    await axios.put(url, body, config);
    dispatch("getAllLongDistanceServices");
    return true;
  } catch (error) {
    return error.response.data.error;
  }
};

const deleteLongDistanceService = async ({ dispatch }, data) => {
  const url = `api/longDistanceService/${data.id}`;
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    await axios.delete(url, config);
    dispatch("getAllLongDistanceServices");
  } catch (error) {
    console.log(error.response.data);
  }
};

const deleteServiceById = async ({ commit, dispatch }, data) => {
  const url = `api/service/${data.serviceId}`;
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.delete(url, config);
    commit("DELETE_CATEGORY_SERVICE_SUCCESS", res.data);
    dispatch("getAllServices", {
      token: data.token,
      search_param: data.search_param,
    });
  } catch (error) {
    commit("DELETE_CATEGORY_SERVICE_FAIL", error.data);
  }
};
const deleteCategoryServiceById = async ({ commit, dispatch }, data) => {
  const url = `api/serviceCategory/${data.categoryServiceId}`;
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.delete(url, config);
    commit("DELETE_SERVICE_SUCCESS", res.data);
    dispatch("fetchServiceCategoriesWithServices", { token: data.token });
  } catch (error) {
    commit("DELETE_SERVICE_FAIL", error.data);
  }
};

const updateService = async ({ commit, dispatch }, data) => {
  let formatted = data.description
    ? data.description.replaceAll("<li>", "<li><span>")
    : "";
  formatted = formatted.replaceAll("</li>", "</span></li>");
  const url = `api/service/${data.serviceId}`;
  const body = JSON.stringify({
    name: data.name,
    display_name: data.displayName,
    minimum: data.minimum,
    first_threshold: data.firstThreshold,
    second_threshold: data.secondThreshold,
    multiplier: data.multiplier,
    min: data.min,
    max: data.max,
    type: data.type,
    service_category_id: data.serviceCategory,
    description: formatted,
    need_verification: data.need_verification,
    added_duration_hours: data.added_duration_hours,
    only_stationary: data.only_stationary,
    company_service: data.company_service,
    service_regulations: data.regulations,
    service_regulations_when_adding: data.regulationsWhenAdding.map(
      (regulation) => {
        return {
          text: regulation.text,
          is_required: regulation.is_required,
          type: "ADDING_SERVICE",
        };
      },
    ),
    promotion_codes_blocked: data.promotion_codes_blocked,
    ...carnetFields(data),
  });
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.put(url, body, config);
    commit("UPDATE_SERVICE_SUCCESS", res.data.message);
    dispatch("getAllServices", {
      token: data.token,
      search_param: data.search_param,
    });
  } catch (error) {
    console.log(error.response);
    commit("UPDATE_SERVICE_SUCCESS", validationMessage(error));
  }
};

const updateCategoryService = async ({ commit, dispatch }, data) => {
  const url = `api/serviceCategory/${data.categoryServiceId}`;
  let formatted = data.description;

  // Akcja buduje wlasne body, wiec kazde nowe pole trzeba tu dopisac - inaczej nie dojdzie do backendu.
  // carnet_group leci TYLKO gdy wywolujacy je poda: backend czyta brak pola jako "nie zmieniaj", a pusty
  // string jako "wyczysc rodzine". Bez tego warunku kazda inna edycja kategorii kasowalaby przynaleznosc
  // do obiadow, czyli VAT 8% i zakladke Obiady.
  const payload = {
    type: data.type,
    name: data.name,
    display_name: data.displayName,
    description: formatted,
  };
  if (data.carnet_group !== undefined) {
    payload.carnet_group = data.carnet_group;
  }
  if (data.has_custom_description !== undefined) {
    payload.has_custom_description = data.has_custom_description;
  }
  let body = JSON.stringify(payload);

  if (data.is_hidden != null) {
    body = JSON.stringify({
      is_hidden: data.is_hidden,
    });
  }

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.put(url, body, config);
    commit("UPDATE_CATEGORY_SERVICE_SUCCESS", res.data.message);
    dispatch("fetchServiceCategoriesWithServices", { token: data.token });
  } catch (error) {
    console.log(error.response);
    commit("UPDATE_CATEGORY_SERVICE_SUCCESS", error.response.data.message);
  }
};

const updatePromotion = async ({ commit, dispatch }, data) => {
  const url = `api/service/${data.serviceId}/promotion`;
  const body = JSON.stringify({
    promotion_date: data.promotion_date,
    promotion_commision: data.promotion_commision,
    promotion_start_date: data.promotion_start_date,
  });
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.put(url, body, config);
    commit("UPDATE_PROMOTION_SUCCESS", res.data.message);
    dispatch("getAllServices", {
      token: data.token,
      search_param: data.search_param,
    });
  } catch (error) {
    console.log(error.response);
    commit("UPDATE_PROMOTION_SUCCESS", error.response.data.message);
  }
};

const addPromotion = async ({ commit, dispatch }, data) => {
  const url = `api/service/${data.serviceId}/promotion`;
  const body = JSON.stringify({
    promotion_date: data.promotion_date,
    promotion_commision: data.promotion_commision,
    promotion_start_date: data.promotion_start_date,
  });
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.post(url, body, config);
    commit("ADD_PROMOTION_SUCCESS", res.data.message);
    dispatch("getAllServices", {
      token: data.token,
      search_param: data.search_param,
    });
  } catch (error) {
    console.log(error.response);
    commit("ADD_PROMOTION_SUCCESS", error.response.data.message);
    console.log(error.response.data.message);
  }
};

const deletePromotion = async ({ dispatch }, data) => {
  const url = `api/service/${data.serviceId}/promotion`;
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    await axios.delete(url, {}, config);
    dispatch("getAllServices", {
      token: data.token,
      search_param: data.search_param,
    });
  } catch (error) {
    console.log(error.response);
  }
};

const addIconToService = ({ commit }, data) => {
  const url = `api/service/${data.serviceId}`;
  let formData = new FormData();
  formData.append("file", data.file);
  const config = {
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };
  axios
    .post(url, formData, config)
    .then((response) => {
      commit("ADD_ICON_SUCCESS", response.data);
    })
    .catch((err) => {
      commit("ADD_ICON_FAIL", err);
    });
};

const fetchUserServicesByUserId = ({ commit }, id) => {
  const url = `api/user/${id}/userServices`;
  axios
    .get(url)
    .then((response) => {
      commit("SET_USER_SERVICES_BY_ID", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};
const fetchUserSubscriptionsByUserId = async ({ commit }, data) => {
  commit("SET_USER_SUBSCRIPTIONS_BY_ID", []);
  let filter_param = "";
  let third_filter_param = "";
  const page_number =
    data.page_number !== null ? `page_number=${data.page_number}&` : "";
  const on_page = data.on_page !== null ? `on_page=${data.on_page}&` : "";
  if (data.filter_param == "ACTIVE") {
    filter_param = `active=true&`;
  } else if (data.filter_param == "FINISHED") {
    filter_param = `active=false&`;
  }
  if (data.third_filter_param == "LUXMED") {
    third_filter_param = `type=LUXMED&`;
  }

  const url =
    `api/userSubscription/user/${data.search_param}?` +
    page_number +
    on_page +
    filter_param +
    third_filter_param;

  await axios
    .get(url)
    .then((response) => {
      console.log(response);
      commit("SET_USER_SUBSCRIPTIONS_BY_ID", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const fetchServiceCategoriesWithServices = async ({ commit }) => {
  const url = `api/serviceCategory/services?with_hidden=true`;
  await axios
    .get(url)
    .then((response) => {
      commit("SET_SERVICES_CATEGORIES_WITH_SERVICES", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const fetchSubscriptionDataById = async ({ commit }, id) => {
  const url = `api/userSubscriptionOption/service/${id}`;
  await axios
    .get(url)
    .then((response) => {
      commit("SET_SUBSCRIPTION_OPTIONS", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};
const setSubsriptionData = async ({ commit }, data) => {
  const url = `api/userSubscriptionOption`;
  const body = JSON.stringify({
    service_id: data.service_id,
    name: data.name,
    month_end_day: data.month_end_day,
    month_start_day: data.month_start_day,
    type: data.type,
    number_of_days: data.number_of_days,
    percentage_discount: data.percentage_discount,
  });
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  await axios
    .post(url, body, config)
    .then(() => {
      commit("");
    })
    .catch((err) => console.log(err));
};
const deleteSubscription = async ({ commit }, id) => {
  const url = `/api/userSubscriptionOption/${id}`;
  await axios
    .delete(url)
    .then((response) => {
      console.log(response);
      commit("");
    })
    .catch((err) => console.log(err));
};
const fetchSubsFilteringParams = async ({ commit }) => {
  const url = `/api/admin/userSubscriptionTypes`;
  await axios
    .get(url)
    .then((response) => {
      commit("SET_FILTERING_PARAMS", response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

const fetchServiceCategoriesTypes = async ({ commit }) => {
  const url = `/api/serviceCategory/types`;
  await axios
    .get(url)
    .then((response) => {
      commit("SET_SERVICE_CATEGORIES_TYPES", response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};
// Each call cancels the previous one (a slow older filter used to overwrite the newer result);
// the sequence also drops a response that arrived before the cancel. Returns true for the newest call.
const fetchSubscriptionsReport = async ({ commit }, body) => {
  if (subscriptionsReportCancel) subscriptionsReportCancel.cancel();
  const source = Axios.CancelToken.source();
  subscriptionsReportCancel = source;
  const requestId = subscriptionsReportSeq.next();

  commit("SET_SUBSCRIPTION_REPORT", []);
  const url = `/api/admin/userSubscriptions/report`;
  const params = {
    date_from: body.date_from,
    date_to: body.date_to,
    orderState: body.orderState || "",
    userId: body.userId || "",
  };
  if (body.type) params.type = body.type;

  try {
    const response = await axios.get(url, {
      params,
      cancelToken: source.token,
    });
    if (subscriptionsReportSeq.isLatest(requestId)) {
      commit("SET_SUBSCRIPTION_REPORT", response.data);
    }
  } catch (error) {
    if (!Axios.isCancel(error)) console.log(error);
  } finally {
    if (subscriptionsReportCancel === source) subscriptionsReportCancel = null;
  }
  return subscriptionsReportSeq.isLatest(requestId);
};

const fetchRecurringOrdersReport = async ({ commit }, body) => {
  commit("SET_RECURRING_ORDERS_REPORT", []);
  const url = `/api/recurringOrder/report`;
  const params = {
    date_from: body.date_from,
    date_to: body.date_to,
    orderState: body.orderState || "",
    userId: body.userId || "",
    servicesIds: body.servicesIds || "",
    subcategoriesIds: body.subcategoriesIds || "",
    categoriesIds: body.categoriesIds || "",
    employeesIds: body.employeesIds || "",
  };
  // Brak typu = wszystkie warianty obiadowe. Domyslne WEEKLY_WORKING_DAYS zostalo tu po starym
  // panelu i przez nie zakladka pokazywala wylacznie karnety 5-dniowe (S3, 16.09.2026) - komponent
  // przestal je wysylac juz wczesniej, ale ten fallback dopisywal je z powrotem.
  if (body.type) {
    params.type = body.type;
  }

  // Wyszukiwarka: PaginationInline nazywa to search_param, reszta widoków filter_param - backend
  // przyjmuje filter_param, tak jak pozostałe listy panelu.
  const searchParam = body.filter_param || body.search_param;
  if (searchParam) {
    params.filter_param = searchParam;
  }

  // Bez page_number/on_page backend oddaje płaską tablicę (tak działa zakładka "Obiady" na karcie
  // użytkownika i pobieranie raportu). Z nimi - obiekt strony z licznikiem subskrypcji.
  if (body.page_number) {
    params.page_number = body.page_number;
  }
  if (body.on_page) {
    params.on_page = body.on_page;
  }

  await axios
    .get(url, { params })
    .then((response) => {
      const data = response.data;
      if (Array.isArray(data)) {
        commit("SET_RECURRING_ORDERS_REPORT", data);
        commit("SET_RECURRING_ORDERS_REPORT_PAGINATION", {
          page_number: 1,
          on_page: data.length,
          total: data.length,
        });
        return;
      }
      commit("SET_RECURRING_ORDERS_REPORT", data.orders || []);
      commit("SET_RECURRING_ORDERS_REPORT_PAGINATION", {
        page_number: data.page_number || 1,
        on_page: data.on_page || params.on_page,
        total: data.total || 0,
      });
    })
    .catch((error) => {
      console.log(error);
    });
};

const fetchRecurringOrdersReportAvailableFilters = async ({ commit }) => {
  commit("SET_RECURRING_ORDERS_REPORT_FILTERS", []);
  const url = `/api/recurringOrder/report/filters`;
  await axios
    .get(url)
    .then((response) => {
      commit("SET_RECURRING_ORDERS_REPORT_FILTERS", response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

const fetchSubscriptionsOrdersReport = async ({ commit }, body) => {
  const url = `/api/admin/userSubscriptionsOrders/report?date_from=${body.date_from}&date_to=${body.date_to}&type=${body.type}`;

  await axios
    .get(url)
    .then((response) => {
      commit("SET_SUBSCRIPTION_ORDERS_REPORT", response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

const handlePaymentsForSubscriptions = async ({ commit }, data) => {
  try {
    const url = `api/userSubscription/handlePayments`;
    const response = await axios.post(url, data);
    commit("SET_USER_SUBSCRIPTIONS_BY_ID", []);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const handlePaymentsForRecurringOrders = async ({ commit }, data) => {
  try {
    const url = `api/recurringOrder/handlePayments`;
    const response = await axios.post(url, data);
    commit("SET_USER_SUBSCRIPTIONS_BY_ID", []);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchExcludedServicesCategoriesDays = async (
  { commit },
  serviceCategoryId,
) => {
  const url = `/api/excludedServiceDays/admin/servicesCategories/${serviceCategoryId}`;
  try {
    const response = await axios.get(url);
    commit("SET_EXCLUDED_SERVICES_CATEGORIES_DAYS", response.data);
  } catch (error) {
    console.log(error);
  }
};

const updateExcludedServicesCategoriesDays = async (
  { dispatch },
  { serviceCategoryId, excludedDays },
) => {
  const url = `/api/excludedServiceDays/admin/servicesCategories/${serviceCategoryId}`;
  try {
    const response = await axios.post(url, {
      dates: excludedDays.map((d) => d.date),
    });
    // After successful update, fetch the updated data
    await dispatch("fetchExcludedServicesCategoriesDays", serviceCategoryId);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export default {
  addService,
  addIconToService,
  getAllServices,
  deleteServiceById,
  updateService,
  updatePromotion,
  addPromotion,
  deletePromotion,
  fetchUserServicesByUserId,
  fetchUserSubscriptionsByUserId,
  fetchServiceCategoriesWithServices,
  updateCategoryService,
  deleteCategoryServiceById,
  addSubCategory,
  getAllSubCategories,
  deleteSubCategory,
  editSubCategory,
  getAllLongDistanceServices,
  addLongDistanceService,
  editLongDistanceService,
  deleteLongDistanceService,
  fetchSubscriptionDataById,
  setSubsriptionData,
  deleteSubscription,
  fetchSubscriptionsReport,
  fetchSubsFilteringParams,
  fetchServiceCategoriesTypes,
  fetchSubscriptionsOrdersReport,
  addServiceCategoryFile,
  removeServiceCategoryFile,
  setServiceCategoryFilePriority,
  handlePaymentsForSubscriptions,
  fetchRecurringOrdersReport,
  handlePaymentsForRecurringOrders,
  fetchRecurringOrdersReportAvailableFilters,
  fetchExcludedServicesCategoriesDays,
  updateExcludedServicesCategoriesDays,
};
